import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import InitiativeDetailsBlock from 'src/apps/Initiative/components/DetailsBlock'
import MetadataBlock from 'src/apps/Initiative/components/MetadataBlock'
import MessageFeed from 'src/apps/Messages/components/Feed'
import RichText from 'src/components/utils/RichText'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const InitiativeHomeLayout1 = () => {
   const { initiative } = useContext(InitiativeHierarchyContext)

   // TODO: Kind of a hack because how the format of body when it is retrieved
   // is different than its format when it is being updated.
   const initiativeBody = initiative?.body?.elements?.[0]?.body || ''

   return (
      <View width="100%" paddingTop="50px">
         <View
            float="left"
            width="100%[a-d] calc(100% - 120px)[e-f]"
            minHeight="90vh"
            borderRight="1px solid #eee[e-f]"
            paddingRight="25px[e-f]">
            <InitiativeDetailsBlock />
            {initiativeBody && (
               <View
                  float="left"
                  width="100%"
                  paddingTop="25px[a-b] 50px[c-f]">
                  <Text
                     size="2[a-c] 2.5[d] 2.5[e-f]"
                     lineHeight="150%"
                     color="#444">
                     <RichText html={initiativeBody} />
                  </Text>
               </View>
            )}
            {initiative.appsMessagesEnabled && (
               <View float="left" width="100%" paddingTop="25px[a-b] 50px[c-f]">
                  <View width="100%" paddingBottom="20px">
                     <Text size="2" weight="medium">
                        Comments
                     </Text>
                  </View>
                  <MessageFeed
                     currentUserCanModerate={initiative.currentUserCanModerate}
                     displayMode="feed"
                     hasUnreadEntries={initiative.thread.hasUnreadEntries}
                     messageLastViewed={initiative.thread.messageLastViewed}
                  />
               </View>
            )}
            <View
               float="left"
               width="100%"
               height="90px[d-f]"
            />
         </View>
         <View
            display="none[a-d] block[e-f]"
            float="left"
            width="120px"
            paddingLeft="25px">
            <MetadataBlock initiative={initiative} />
         </View>
      </View>
   )
}

export default InitiativeHomeLayout1
